import { z } from 'zod';

// ---------------------------------------------------------------------------
// Favourites: POST /v1/favourites/watch
// ---------------------------------------------------------------------------

export const FavouriteWatchRequestSchema = z.object({
  email: z.string().email(),
  wallpaperIds: z
    .array(z.number().int().positive())
    .min(1, 'At least one wallpaper id is required')
    .max(50, 'At most 50 wallpaper ids per request'),
  siteCode: z.string().min(2).max(8).default('pl'),
  langCode: z.string().regex(/^[a-z]{2}$/).default('pl'),
  reconcile: z.boolean().default(false),
});
export type FavouriteWatchRequest = z.infer<typeof FavouriteWatchRequestSchema>;

export const FavouriteWatchResponseSchema = z.object({
  ok: z.literal(true),
});
export type FavouriteWatchResponse = z.infer<typeof FavouriteWatchResponseSchema>;
